import React from "react";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";
import BaseSelect from "../baseSelect/BaseSelect";

class LanguageSelection extends React.Component {
  state = {
    selected: undefined
  };

  async componentDidMount() {
    await i18n.init();
    let lang = i18n.language.toLowerCase();
    if (/-/.test(lang)) lang = lang.split("-")[0];
    const selected = i18n.languageOptions.filter(lng => lng.value === lang)[0];
    this.setState({ selected });
  }

  render() {

    const customStyles = {
      control: (provided, {isFocused}) => ({
        ...provided,
        zIndex: 100,
        borderColor: isFocused ? "#54BF8D" : "#ced4da",
        boxShadow:  isFocused ? "0 0 0 0.15rem rgba(67, 152, 112, 0.25)": "none",
        '&:hover': {
          borderColor: isFocused ? "#54BF8D" : "#ced4da",
          boxShadow:  isFocused ? "0 0 0 0.15rem rgba(67, 152, 112, 0.25)": "none"
        }
      }),
      option: (provided, {isSelected}) => ({
        ...provided,
        backgroundColor: isSelected ? "#b2c9c4" : "#FFFFFF",
        '&:hover': {
          backgroundColor: "#54BF8D",
          color: "#FFFFFF"
        }
      }),
      menuPortal: provided => ({
        ...provided,
        zIndex: 100
      }),

      singleValue: (provided, state) => {
        return { ...provided };
      }
    }
    return (
      <div style={{ width: "10em" }}>
        <BaseSelect
          styles={customStyles}
          isSearchable={false}
          options={i18n.languageOptions}
          value={this.state.selected}
          onChange={selected => {
            i18n
              .changeLanguage(selected.value)
              .then(() => this.setState({ selected }));
          }}
        />
      </div>
    );
  }
}

export default withTranslation()(LanguageSelection);
